import styled, { css } from 'styled-components/macro';
import { ReactComponent as Chevron } from '../assets/icons/chevron-down.svg';
import { ReactComponent as X } from '../assets/icons/x.svg';
import { ReactComponent as Search } from '../assets/icons/search.svg';
import { overflowEllipsis } from '../styles/utils';

export const ButtonFilter = css`
  padding: 0 1.5rem;
  display: flex;
  justify-content: center;
  ${props =>
    props.isActive &&
    css`
      display: flex;
      justify-content: space-between;
      flex-grow: 1;
    `}
  border: 1px solid
    ${props =>
      props.isActive && !props.open ? props.theme.brand : 'transparent'};
  > p {
    /* color: ${props => props.theme.brand}; */
    margin-right: 1rem;
  }
`;

export const FilterOptionSelectedLi = styled.li`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 0.8rem 0;
  text-transform: capitalize;

  svg {
    fill: ${props => props.theme.black};
  }
  color: ${props => props.theme.black};

  ${props =>
    props.disabled &&
    css`
      svg {
        fill: ${props => props.theme.dustierGray};
      }
      color: ${props => props.theme.dustyGray};
    `}
  ${props =>
    props.isActive &&
    css`
      &&&& {
        svg {
          fill: ${props => props.theme.brand};
        }
        color: ${props => props.theme.brand};
      }
    `}
`;

export const transactionFilter = css`
  display: flex;
  align-items: center;
  position: relative;
  padding: 0 1rem;
  margin: -1px 0;
  cursor: default;
  height: ${props => !props.open && 'calc(100% + 2px)'};
  ${props =>
    !props.rightEnd &&
    !props.open &&
    !props.isActive &&
    css`
      &::after {
        content: '';
        height: 100%;
        /* height: 80%; */
        position: absolute;
        /* top: 10%; */
        right: 0;
        border-left: ${props => props.theme.defaultBorder};
      }
    `}
  ${props =>
    !props.leftEnd &&
    css`
      margin-left: ${props => (props.open ? '-2px' : '-1px')};
    `}
`;

export const TransactionFilterDiv = styled.div`
  ${transactionFilter} 
  flex-grow: ${props => props.scale};
  min-width: 60px;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none; /* firefox */
  border: 1px solid
    ${props =>
      props.isActive && !props.open ? props.theme.brand : 'transparent'};
  z-index: ${props => props.open && 2};

  ${props =>
    props.open &&
    css`
      background-color: white;
      ${props => props.theme.defaultDropShadow}
      padding-top: 0.4rem;
      border-color: white;
    `}
  ::-webkit-scrollbar {
    display: none;
  }
  > h5 {
    color: ${props => props.theme.dustyGray};
  }
  ${props =>
    !props.noMaxWidth &&
    css`
      max-width: 190px;
      @media screen and (min-width: 375px) {
        max-width: 235px;
      }
      @media screen and (min-width: 430px) {
        max-width: 300px;
      }
      @media screen and (min-width: 490px) {
        max-width: 360px;
      }
      @media screen and (min-width: 550px) {
        max-width: 380px;
      }
    `}
  ${props =>
    props.disabled
      ? css`
          cursor: not-allowed;
        `
      : css`
          &:hover {
            ${FilterOptionSelectedLi} {
              color: black;
            }
          }
        `}
    ${props =>
      props.fixedWidth &&
      css`
        @media screen and (max-width: 1023px) {
          && {
            width: 50px;
            max-width: 50px;
          }
        }
        @media screen and (min-width: 1024px) {
          && {
            width: 105px;
            max-width: 105px;
          }
        }
      `}
    ${props =>
      props.setWidth &&
      css`
        width: ${props.setWidth};
      `}
    ${props =>
      props.outline &&
      css`
        border: 1px solid ${props => props.theme.brand};
      `}
`;
TransactionFilterDiv.defaultProps = {
  scale: 1
};

export const ChevronSvg = styled(Chevron)`
  ${props => props.open && 'transform: rotate(180deg);'};
  width: 1rem;
  margin-left: 10px;
  z-index: 0;
`;

export const TransactionFilterItemLi = styled.li`
  text-transform: capitalize;
  user-select: none;
  padding: 0.8rem 0;
  ${overflowEllipsis}
  ${props =>
    props.selected &&
    css`
      color: ${props.theme.brand};
    `}
  &:hover {
    color: ${props => props.theme.brand};
  }
`;

export const InactiveLabelLi = styled.li`
  text-transform: capitalize;
  user-select: none;
  padding: 0.8rem 0;
  ${props =>
    !props.hideBorder &&
    css`
      border-bottom: ${props => props.theme.defaultBorder};
    `}
  color: ${props => props.theme.dustyGray};
`;

// TransactionSearchFilter
export const TransactionSearchFilterDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -1px;
  padding-left: ${props => (props.small ? '10px' : '20px')};
  padding-right: ${props => (props.small ? '10px' : '20px')};
  border: ${props => props.theme.defaultBorder};
  border-bottom: ${props =>
    props.isActive
      ? `2px solid ${props.theme.brand}`
      : `${props.theme.defaultBorder}`};

  background-color: white;
  z-index: 1;
  /* will eventually need some dynamic width styles based on touch events */
  width: ${props => (!props.isActive ? 'calc((50%/3) + 2px)' : '100%')};

  height: ${props => (props.dropdownState ? '160px' : '40px')};
  ${props => props.dropdownState && props.theme.defaultDropShadow}
  > h5 {
    color: ${props => props.theme.dustyGray};
  }
  cursor: pointer;
`;

export const SearchInput = styled.input`
  padding-left: 15px;
  outline: none;
  width: 100%;
  border-width: 0;
  background-color: white;
`;

export const XSvg = styled(X)`
  width: 6px;
  fill: ${props => props.theme.dustyGray};
`;
export const SearchSvg = styled(Search)`
  fill: ${props => props.theme.mercury};
`;
